(ns app.front.view.group.admin.inspections.qualification
  (:require [app.front.entities :as entities]
            [app.front.ui.tag-type-editor :as ui-tag-type-editor]
            [app.front.view.group.admin.common :as acommon]
            [app.i18n.model :as i18n-model]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::inspector-qualifications
  (fn [[_ group-id _]]
    [(rf/subscribe [::entities/entities {:entity/type            :entity.type/inspector-qualification
                                         :domain/authority-group group-id}])
     (rf/subscribe [:language])])
  (fn [[qualifications lang]]
    (->> qualifications
         (map #(let [enabled?          (-> % :group/_inspector-qualification seq boolean)
                     used-in-template? (-> % :inspection.template.kind/_inspector-qualifications seq boolean)]
                 (merge (select-keys % [:db/id
                                        :entity/type
                                        :inspector-qualification/names])
                        {:enabled?          enabled?
                         :used-in-template? used-in-template?})))
         (sort-by :inspector-qualification/names (i18n-model/localized-string-comparator lang))
         (map #(update % :inspector-qualification/names i18n-model/strings-map)))))

(rf/reg-sub ::enabled-inspector-qualification-id-set
  (fn [[_ group-id lang]]
    (rf/subscribe [::inspector-qualifications group-id lang]))
  (fn [qualifications _]
    (->> qualifications
         (filter :enabled?)
         (map :db/id)
         set)))

(rf/reg-event-fx ::create-inspector-qualification
  (fn [_ [_ authority-group-id names on-done]]
    {:comm/command {:command    :inspection/create-inspector-qualification
                    :method     :post
                    :data       (util/mmap {:data {:inspector-qualification/names names}}
                                           authority-group-id)
                    :on-success [::create-inspector-qualification.success on-done]
                    :notify     {:success :inspector-qualification/created}}}))

(rf/reg-event-fx ::create-inspector-qualification.success
  (fn [_ [_ on-done status resp]]
    (on-done)
    {:dispatch [::entities/apply-changes status resp]}))

(rf/reg-event-fx ::edit-inspector-qualification
  (fn [_ [_ inspector-qualification-id names]]
    {:comm/command {:command    :inspection/edit-inspector-qualification
                    :method     :post
                    :data       {:id   inspector-qualification-id
                                 :data {:inspector-qualification/names names}}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-fx ::delete-inspector-qualification
  (fn [_ [_ inspector-qualification-id]]
    {:comm/command {:command    :inspection/delete-inspector-qualification
                    :method     :post
                    :data       {:id inspector-qualification-id}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(rf/reg-event-fx ::toggle-inspector-qualification
  (fn [_ [_ inspector-qualification-id enabled?]]
    {:comm/command {:command    :inspection/toggle-inspector-qualification
                    :method     :post
                    :data       (util/mmap {:id inspector-qualification-id} enabled?)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :changes-saved}}}))

(defn view [{:keys [tr authority-group-id]}]
  (let [lang           (<sub [:language])
        qualifications (<sub [::inspector-qualifications authority-group-id lang])]
    [acommon/section
     {}
     [:div.flex.flex-col.gap-y-4
      [ui-tag-type-editor/editor
       (util/mmap {:values                qualifications
                   :name-attr             :inspector-qualification/names
                   :tag-type-name         (tr [:inspector-qualification/tag-type-name])
                   :on-create             (fn [{:keys [names on-done]}]
                                            (>evt [::create-inspector-qualification authority-group-id names on-done]))
                   :on-end-edit           (fn [{:keys [:db/id :inspector-qualification/names]}]
                                            (>evt [::edit-inspector-qualification id names]))
                   :on-delete             (fn [{:keys [:db/id]}]
                                            (>evt [::delete-inspector-qualification id]))
                   :on-toggle             (fn [enabled? {:keys [:db/id]}]
                                            (>evt [::toggle-inspector-qualification id enabled?]))
                   :selected?             (comp (<sub [::enabled-inspector-qualification-id-set authority-group-id lang]) :db/id)
                   :remove-confirmation   #(when (:used-in-template? %) (tr [:inspector-qualification/delete-confirm]))
                   :deselect-confirmation #(when (:used-in-template? %) (tr [:inspector-qualification/deselect-confirm]))}
                  tr)]]]))
